/* ------------------------------------------------------------
   PRODUCT CARD ZOOM HOVER - Desktop & Mobile
   - ONLY applies to product-card elements
   - Does NOT apply to collection grid
   - Desktop: zoom on mouseover
   - Mobile: zoom on touch
------------------------------------------------------------ */

(function () {
  'use strict';

  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    // Target ONLY product-card elements, NOT collection grids
    const productCards = document.querySelectorAll('product-card .card-gallery');

    if (!productCards.length) return;

    productCards.forEach(function (gallery) {
      const slidesContainer = gallery.querySelector('slideshow-slides');
      if (!slidesContainer) return;

      const slides = slidesContainer.querySelectorAll('slideshow-slide');
      if (!slides || slides.length < 2) return;

      const firstSlide = slides[0];
      const secondSlide = slides[1];
      const firstImage = firstSlide.querySelector('img');
      const secondImage = secondSlide.querySelector('img');

      if (!firstImage || !secondImage) return;

      let isZoomed = false;
      let autoHideTimer = null;

      // Style setup for zoom effect
      function setupZoomStyles() {
        // First slide - zoom effect
        firstImage.style.transition = 'transform 0.6s ease-out';
        firstImage.style.transformOrigin = 'center center';

        // Second slide - overlay setup
        secondSlide.style.position = 'absolute';
        secondSlide.style.top = '0';
        secondSlide.style.left = '0';
        secondSlide.style.width = '100%';
        secondSlide.style.height = '100%';
        secondSlide.style.opacity = '0';
        secondSlide.style.pointerEvents = 'none';
        secondSlide.style.transition = 'opacity 0.6s ease-out';
        secondSlide.style.zIndex = '10';

        secondImage.style.transition = 'transform 0.6s ease-out';
        secondImage.style.transformOrigin = 'center center';
      }

      function showZoom() {
        if (isZoomed) return;
        isZoomed = true;

        // Zoom first image
        firstImage.style.transform = 'scale(1.15)';

        // Show and zoom second image
        secondSlide.style.opacity = '1';
        secondImage.style.transform = 'scale(1.15)';

        // Auto revert after 3 seconds on mobile
        if (window.matchMedia('(hover: none)').matches) {
          if (autoHideTimer) clearTimeout(autoHideTimer);
          autoHideTimer = setTimeout(hideZoom, 3000);
        }
      }

      function hideZoom() {
        if (!isZoomed) return;
        isZoomed = false;

        if (autoHideTimer) {
          clearTimeout(autoHideTimer);
          autoHideTimer = null;
        }

        // Reset zoom
        firstImage.style.transform = 'scale(1)';
        secondSlide.style.opacity = '0';
        secondImage.style.transform = 'scale(1)';
      }

      // Initialize styles
      setupZoomStyles();

      // Desktop hover events
      if (window.matchMedia('(hover: hover)').matches) {
        gallery.addEventListener('mouseenter', showZoom);
        gallery.addEventListener('mouseleave', hideZoom);
      }

      // Mobile touch events
      if (window.matchMedia('(hover: none)').matches) {
        gallery.addEventListener('touchstart', function (e) {
          showZoom();
        }, { passive: true });

        gallery.addEventListener('touchend', function () {
          // Let the auto-hide timer handle the reset
        }, { passive: true });
      }
    });
  }
})();
